import React, { createContext, useContext, useState } from "react";

interface AnimationContextType {
  attemptToExecuteAnimation: () => void;
  taskJustSubmitted: boolean;
}

const ProcessAnimationContext = createContext<AnimationContextType | undefined>(
  undefined,
);

/**
 * This allows a completion animation to play after
 * a user submits a task and hands the process
 * off to the user of the next task's role.
 *
 * Calling attemptToExecuteAnimation enables the
 * animation to be played.
 *
 * @returns Animation Context
 */
export const useProcessAnimationContext = () => {
  const ctx = useContext(ProcessAnimationContext);
  if (!ctx) return;
  return ctx;
};

interface AnimationProviderProps {
  attemptToExecuteAnimation?: () => void;
  children: React.ReactNode;
}

export const ProcessAnimationProvider: React.FC<AnimationProviderProps> = ({
  attemptToExecuteAnimation,
  children,
}) => {
  const [justSubmitted, setJustSubmitted] = useState(false);
  const exec = () => {
    setJustSubmitted(true);
    attemptToExecuteAnimation?.();
  };
  return (
    <ProcessAnimationContext.Provider
      value={{
        attemptToExecuteAnimation: exec,
        taskJustSubmitted: justSubmitted,
      }}
    >
      {children}
    </ProcessAnimationContext.Provider>
  );
};
